var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_65613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08301 10.5007V7.00065C4.08301 6.2271 4.3903 5.48524 4.93728 4.93826C5.48426 4.39128 6.22613 4.08398 6.99967 4.08398C7.77322 4.08398 8.51509 4.39128 9.06207 4.93826C9.60905 5.48524 9.91634 6.2271 9.91634 7.00065V10.5007",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91699 12.25C2.91699 12.4047 2.97845 12.5531 3.08785 12.6625C3.19724 12.7719 3.34562 12.8333 3.50033 12.8333H10.5003C10.655 12.8333 10.8034 12.7719 10.9128 12.6625C11.0222 12.5531 11.0837 12.4047 11.0837 12.25V11.6667C11.0837 11.3572 10.9607 11.0605 10.7419 10.8417C10.5232 10.6229 10.2264 10.5 9.91699 10.5H4.08366C3.77424 10.5 3.47749 10.6229 3.2587 10.8417C3.03991 11.0605 2.91699 11.3572 2.91699 11.6667V12.25Z",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7H12.8333",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7917 2.625L10.5 2.91667",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 7H1.75033",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 1.16602V1.74935",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.875 2.875L3.28742 3.28742",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7V10.5",
    stroke: "#E73C3C",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_65613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.9f23c173ed8c5a6c9e7ae4a085a156ff.svg";
export { ForwardRef as ReactComponent };